import { render, staticRenderFns } from "./clientFundDataList.vue?vue&type=template&id=3b4fddc3&scoped=true"
import script from "./clientFundDataList.vue?vue&type=script&lang=js"
export * from "./clientFundDataList.vue?vue&type=script&lang=js"
import style0 from "./clientFundDataList.vue?vue&type=style&index=0&id=3b4fddc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4fddc3",
  null
  
)

export default component.exports